import { render, staticRenderFns } from "./categoryList.vue?vue&type=template&id=ddf03f44&scoped=true"
import script from "./categoryList.vue?vue&type=script&lang=js"
export * from "./categoryList.vue?vue&type=script&lang=js"
import style0 from "./categoryList.vue?vue&type=style&index=0&id=ddf03f44&prod&lang=scss"
import style1 from "./categoryList.vue?vue&type=style&index=1&id=ddf03f44&prod&lang=scss"
import style2 from "./categoryList.vue?vue&type=style&index=2&id=ddf03f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf03f44",
  null
  
)

export default component.exports